import type { InventoryDetailSaleContext } from '../../components/inventory/InventoryDetailModal/InventoryDetailModal';

function toSaleDateIso(saleDate: string | Date): string {
  if (saleDate instanceof Date) {
    return saleDate.toISOString();
  }
  return saleDate;
}

/** Builds saleContext for InventoryDetailModal from a sale line + order date. */
export function buildInventoryDetailSaleContext(params: {
  finalPrice: number;
  saleDate: string | Date;
}): InventoryDetailSaleContext {
  return {
    finalPrice: params.finalPrice,
    saleDate: toSaleDateIso(params.saleDate),
  };
}

/** Resolves saleContext when opening piece detail from an order (Gestión de Ventas, etc.). */
export function saleContextFromOrderItem(
  items: Array<{
    finalPrice: number;
    warehouseInventoryProduct?: { id?: number | null } | null;
  }>,
  warehouseInventoryProductId: number,
  saleDate: string | Date,
): InventoryDetailSaleContext | undefined {
  const line = items.find(
    (item) => item.warehouseInventoryProduct?.id === warehouseInventoryProductId,
  );
  if (line == null) return undefined;
  return buildInventoryDetailSaleContext({
    finalPrice: line.finalPrice,
    saleDate,
  });
}
